import React from 'react';
import '../styles/Bulldozers.css';

const Bulldozers = () => {
  return (
    <section className="bulldozers">
      <div className="bulldozer-container">
        <div className="bulldozer-image">
          <img 
            src="/assets/images/bulldozer.png" 
            alt="Bulldozer LiuGong" 
          />
        </div>
        
        <div className="bulldozer-text">
          <h2 className="bulldozer-title">BULLDOZERS</h2>
          <h3 className="bulldozer-models">LD20D – LD36D</h3>
          <p className="bulldozer-tagline">"Puissance brute, précision garantie."</p>
          
          <div className="bulldozer-description">
            <p>
              Les bulldozers LiuGong offrent puissance, stabilité et maniabilité
              pour tous les travaux lourds. Robustes et performants, ils
              garantissent une efficacité maximale sur tous les terrains.
            </p>
          </div>
          
          <a href="/products/bulldozer" className="bulldozer-button">
            NOS BULLDOZERS
          </a>
        </div>
      </div>
    </section>
  );
};

export default Bulldozers;